import { createNamespace, addUnit } from '../utils';

var _createNamespace = createNamespace('avatar'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    figure: {
      type: [Number, String],
      default: 1
    },
    size: [Number, String],
    round: Boolean,
    background: String,
    radius: [Number, String]
  },
  methods: {
    genFigure: function genFigure() {
      if (typeof this.figure === 'number') {
        return "http://mui.ucmed.cn/images/default/avatar" + this.figure + ".png";
      }

      return this.figure;
    }
  },
  render: function render() {
    var h = arguments[0];
    var slots = this.slots,
        size = this.size,
        round = this.round,
        background = this.background,
        radius = this.radius;
    var contentStyle = {
      width: addUnit(size),
      height: addUnit(size),
      borderRadius: addUnit(radius),
      background: background
    };
    return h("div", {
      "attrs": {
        "role": "avatar"
      },
      "class": bem({
        round: round
      })
    }, [h("img", {
      "attrs": {
        "src": this.genFigure()
      },
      "style": contentStyle
    }), slots()]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/avatar/index.js
// module id = null
// module chunks = 